import { Draft, produce } from 'immer';

export const produceNext = <T>(
  base: T | undefined,
  recipe: (draft: Draft<T> | undefined) => T | void
): T | undefined => {
  const next = produce<T | undefined, T | undefined>(base, (draft) =>
    recipe(draft as Draft<T> | undefined)
  );

  return next !== undefined && next !== base ? next : undefined;
};
